import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21 8.798h-4c-.4 0-.8.293-.9.684L14 15.445 8.9.685C8.8.294 8.4 0 8 0s-.8.294-.9.685L4.3 8.799H1c-.6 0-1 .39-1 .977s.4.978 1 .978h4c.4 0 .8-.293.9-.684L8 4.105l5.1 14.86c.1.39.5.684.9.684s.8-.294.9-.684l2.8-8.114H21c.6 0 1-.391 1-.978s-.4-1.075-1-1.075"
    }, null, -1)
  ]))]))
}
export default { render: render }